import { ADMSRDF } from '../../const/C';

/** Сортировка списка схем для отображния таксономии.
 *  values - массив со списком значений 
 *  provider - провайдер получения данных см. AdmsDataProvider
 *  uri - предикат, который содержит объекты с URI схемами
 * 
 * Аналогичная сортировка используется в sortTaxonomy из AdmsActions.js 
 */
export const sortConceptSchemesTaxonomy = (values, provider, uri='http://www.w3.org/ns/dcat#themeTaxonomy', lang=undefined) => {
  //console.log("helper.js sortConceptSchemesTaxonomy", values, provider, uri, lang);
  const subset = (values && Array.isArray(values))? provider.subsetValuesByURI(values, uri):[];
  const schemes = provider.subsetByLangOrEmpty(subset, lang);
  let j = 0;
  for (let i = 0; i < ADMSRDF.TAXONOMY_SEQUENCE.length; i++) {
      const IRI = ADMSRDF.TAXONOMY_SEQUENCE[i];
      const pos = schemes.map(item => item.object.value).indexOf(IRI);
      if (pos<0) continue;
      if (j==pos) {j++ ; continue};
      if (j>=(schemes.length-1)) break;
      [schemes[pos], schemes[j]] = [schemes[j], schemes[pos]];
      j++;
  }
  return schemes;
}
